module.exports = __webpack_public_path__ + "img/c2-1.a7a48574.png";